import React, { useEffect } from "react";
import "./BookSection.css";

import bookImg from "../../assets/images/nmd-book.jpg";

const BookSection = () => {

  useEffect(() => {
    const elements = document.querySelectorAll(".zoom-scroll");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -50px 0px" }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="book-section">

      <div className="book-container">

        {/* Left Text */}
        <div className="book-text zoom-scroll">
          <h2>Best Guidance – Revamping Business With Modern Marketing</h2>
          
          <p>
            In today’s fast-paced digital world, staying ahead means adapting <strong>smarter marketing strategies</strong>. That’s exactly what our founder, Mr. Navnath Darekar, dives into in his book <strong>Revamping Business with Modern Marketing</strong>. Backed by his hands-on experience and deep understanding of the <strong>digital marketing landscape</strong>, this book offers a clear and practical overview of how modern marketing works and why it matters.
          </p>
          
          <p>
            Available on popular platforms like <strong>Amazon</strong> and Flipkart, the book has become a favorite among readers—especially students and beginners eager to explore the field. It’s been well-received for its simple language, actionable insights, and no-nonsense approach. If you're looking to understand how digital marketing can truly transform a business, this book is a great place to start.
          </p>
        </div>

        {/* Right Image */}
        <div className="book-image zoom-scroll">
          <img src={bookImg} alt="Book by Founder" />
        </div>

      </div>
    </section>
  );
};

export default BookSection;
